import { useAppSelector } from "../framework/customStore";
import { calendarDaySelectors } from "../store/calendarSlice";

export const useSelectCalendarDay = (day: string) => {
    const state = useAppSelector((state) => state.calendar);
    return calendarDaySelectors.selectById(state, day);
};